import {IUserTicketPrize} from "../../firebase/topics/in-game-challenges/tickets-update/user-tickets-update-topic.model.interface";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {InGameTicketPrizeType} from "./abstract/in-game-ticket-prize-types";
import {InGameTicketPrizeAbstract} from "./abstract/in-game-ticket-prize.abstract";

/**
 * https://evokeplc.atlassian.net/wiki/spaces/CRMSX/pages/542710740/Bonus+Types
 * Jackpot vouchers
 *
 * A variant on both the Freespins and the vouchers where the users can only get real money if they win the jackpot, in all other cases the wins are voided
 * The logic was always like this:
 * * When you play on JP free spin or JP voucher the JP winning goes to bankroll
 * * When you play on bonus money (restricted) the JP wining was return according the logic – before RMF it goes to Bonus as in Casino remining used to go to bonus
 */
export class InGameTicketJackpotFreePlayVoucherPrize extends InGameTicketPrizeAbstract {
    constructor(protected _prizeData: IUserTicketPrize, private services: IServiceFactoryExtended) {
        if (InGameTicketPrizeType.JackpotFreePlayVoucher !== _prizeData.prizeType) {
            throw new Error("Jackpot Free Play Voucher cannot be given this prizeType" + _prizeData.prizeType);
        }
        super(_prizeData);
    }
    public prizeString() {
        // return this.services.translation.translate("IGC_FREE_SPINS_PRIZE_TEMPLATE", {prizeValue: this._prizeData.prizeValue});
        return `${this._prizeData.prizeValue} jackpot freeplay voucher${this._prizeData.prizeValue>1 ? 's' : ''}`;
    }
}
